var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPinterest = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 239.82 300",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,228.73c-19.23,0-37.24-10.57-43.48-22.69,0,0-10.31,41.83-12.56,50-3.72,13.69-10.82,27.28-17.4,38.11-9.45,12.3-20.27,3.2-21.57-8.06-.43-12.47,0-27.19,3.12-40.7,3.46-14.72,22.86-99,22.86-99s-5.71-11.61-5.71-28.76c0-26.93,15.24-47,34.29-47,16.2,0,24,12.38,24,27.28,0,16.62-10.39,41.48-15.67,64.43-4.51,19.32,9.44,35,28.06,35,33.69,0,56.47-44.25,56.47-96.57,0-39.83-26.25-69.63-74.05-69.63-54,0-87.65,41.14-87.65,87,0,15.85,4.59,27,11.78,35.59,3.29,4,3.72,5.54,2.51,10.13-.87,3.38-2.77,11.35-3.64,14.55-1.21,4.59-4.85,6.24-8.92,4.51C11.61,172.44,0,144.63,0,113.46,0,61.84,42.61,0,127.14,0,195,0,239.82,50.23,239.82,104.1,240.08,175.47,201.28,228.73,144,228.73Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPinterest, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pinterest.d7c9ac5a.svg";
export { ForwardRef as ReactComponent };